/**
 * Value for "orderSource" custom field for door-to-door carts
 */
export const D2DOrderSource = 'doorToDoor'
